/**
 *
 * FormTimezonePicker
 *
 */
import React, { memo, useMemo } from 'react';
import { SupportedLocaleList, SupportedSegmentList } from 'app/constants';
import timezones from 'app/assets/data/timezones';
import { FormSearchableControl } from '@assetic/web-components';
import { FastField, Field } from 'formik';
import { selectPreloadState } from 'app/helpers/PreloadStateHook/slice/selectors';
import { useSelector } from 'react-redux';
import { Grid } from '@mui/material';
import { SectionHeader } from '../Headers';

type selectItems = {
  value: string;
  label: string;
};

interface Props {}

export const FormRegionPicker = memo((props: Props) => {
  const [localeKeyValues] = React.useState<selectItems[]>(() =>
    Object.keys(SupportedLocaleList).map(l => ({
      label: SupportedLocaleList[l],
      value: SupportedLocaleList[l],
    })),
  );

  const [timezoneKeyValues] = React.useState<selectItems[]>(() =>
    timezones.map(tz => ({
      label: tz.label,
      value: tz.id,
    })),
  );

  const { userSegment } = useSelector(selectPreloadState);

  const segmentKeyValues = useMemo<selectItems[]>(() => {
    if (!userSegment.loading) {
      if (userSegment.error) {
        return Object.keys(SupportedSegmentList).map(s => ({
          label: SupportedSegmentList[s],
          value: SupportedSegmentList[s],
        }));
      }

      if (userSegment.data?.contents.length) {
        return userSegment.data.contents.map(s => ({
          label: s.segment_name,
          value: s.segment_name,
        }));
      }
    }
    return [];
  }, [userSegment.data, userSegment.loading, userSegment.error]);

  return (
    <>
      <SectionHeader title="Region" />

      <Grid container spacing={2}>
        <Grid item lg={4} xs={12}>
          <Field
            name="segment_name"
            label="Segment"
            component={FormSearchableControl}
            items={segmentKeyValues}
            itemsLoading={userSegment?.loading}
            required
          />
        </Grid>
        <Grid item lg={4} xs={12}>
          <FastField
            name="locale"
            label="Locale"
            component={FormSearchableControl}
            items={localeKeyValues}
            required
          />
        </Grid>
        <Grid item lg={4} xs={12}>
          <FastField
            name="timezone"
            label="Timezone"
            component={FormSearchableControl}
            items={timezoneKeyValues}
          />
        </Grid>
      </Grid>
    </>
  );
});
